import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 7l5 5l-5 5","key":"svg-1"}]]

const IconChevronsRight = createReactComponent('outline', 'chevrons-right', 'ChevronsRight', __iconNode);

export default IconChevronsRight;